/* eslint-disable @typescript-eslint/no-non-null-assertion */
import { useEffect, useState, useContext } from 'react'
import { useLocation } from 'react-router-dom'
import { MenuContext } from '../../contexts/menu-context'
import { andTheme } from '../../styles/theme'
import Button from '../atoms/Button/button'
import { NavMenu, MenuItem, MenuItemLink, ButtonContainer } from './navbar-styles'

type NavBarProps = {
  signOutHandler?: () => void
}

type MenuItemType = {
  route: string
  text: string
  onClick?: () => void
}

const NavBar = ({ signOutHandler }: NavBarProps) => {
  const location = useLocation()
  const { setMenuOpen } = useContext(MenuContext)

  const [isDesktop, setDesktop] = useState(window.innerWidth > andTheme.breakpoints.lg)
  const updateMedia = () => {
    setDesktop(window.innerWidth > andTheme.breakpoints.lg)
  }

  useEffect(() => {
    window.addEventListener('resize', updateMedia)
    return () => window.removeEventListener('resize', updateMedia)
  }, [])

  const menuStructure: MenuItemType[] = [
    { route: '/', text: 'Home', onClick: () => setMenuOpen(false) },
    { route: '/report', text: 'Reporting', onClick: () => setMenuOpen(false) },
    { route: '/faq', text: 'FAQ', onClick: () => setMenuOpen(false) }
  ]

  if (!isDesktop) {
    menuStructure.push({ route: '/profile', text: 'My Profile', onClick: () => setMenuOpen(false) })
  }

  return (
    <NavMenu>
      {menuStructure.map(menuItem => {
        return location.pathname === menuItem.route ? (
          <MenuItem key={menuItem.text} onClick={menuItem.onClick}>
            {menuItem.text}
          </MenuItem>
        ) : (
          <MenuItemLink key={menuItem.text} onClick={menuItem.onClick} to={menuItem.route}>
            {menuItem.text}
          </MenuItemLink>
        )
      })}
      {!isDesktop && (
        <ButtonContainer>
          <Button buttonText="Sign Out" onClick={signOutHandler!} maxContent isRightArrow={false} />
        </ButtonContainer>
      )}
    </NavMenu>
  )
}

export default NavBar
